import React, { FC } from 'react';

import { useLoggedInStatus } from '../../../hooks';
import { cn, resultIf, RouteDictionary } from '../../../utils';
import { Button, CustomLink, SecondaryButton } from '../../common';
import { SecondaryButtonColor } from '../../common/buttons/decorators/SecondaryButton/SecondaryButton';

import './MobileNavigation.scoped.scss';

interface Props {
  active: boolean;
  onNavigated: () => void;
}

const MobileNavigation: FC<Props> = ({ active, onNavigated }) => {
  const isLoggedIn = useLoggedInStatus();
  return (
    <nav className={cn('mobile-navigation', resultIf(active, 'active'))}>
      <div className="mobile-navigation__inner">
        <ul className="mobile-navigation__list">
          {!isLoggedIn && (
            <li className="mobile-navigation__login">
              Войти как
              <SecondaryButton color={SecondaryButtonColor.GREEN}>
                <CustomLink to={RouteDictionary.ENTER}>Инвестор</CustomLink>
              </SecondaryButton>
              или
              <SecondaryButton color={SecondaryButtonColor.ORANGE}>
                <Button>Заемщик</Button>
              </SecondaryButton>
            </li>
          )}
          {isLoggedIn && (
            <>
              <li className="mobile-navigation__element">
                <CustomLink
                  onClick={onNavigated}
                  className="mobile-navigation__link"
                  to={RouteDictionary.REFERRAL}
                >
                  Реферальный доход
                </CustomLink>
              </li>
              <li className="mobile-navigation__element">
                <CustomLink
                  onClick={onNavigated}
                  className="mobile-navigation__link"
                  to={RouteDictionary.DOCUMENTS_TO_PROJECT}
                >
                  Документы
                </CustomLink>
              </li>
              <li className="mobile-navigation__element">
                <CustomLink
                  onClick={onNavigated}
                  className="mobile-navigation__link"
                  to={RouteDictionary.TRACK_RECORD}
                >
                  Трек рекорд
                </CustomLink>
              </li>
              <li className="mobile-navigation__element">
                <CustomLink
                  onClick={onNavigated}
                  className="mobile-navigation__link"
                  to={RouteDictionary.PROFILE}
                >
                  Профиль
                </CustomLink>
              </li>
              <li className="mobile-navigation__element">
                <CustomLink
                  onClick={onNavigated}
                  className="mobile-navigation__link"
                  to={RouteDictionary.LOGOUT}
                >
                  Выйти из аккаунта
                </CustomLink>
              </li>
            </>
          )}
        </ul>
      </div>
    </nav>
  );
};

export default MobileNavigation;
